import React, { Component } from "react";
import { Button, FormLayout, TextField } from "@shopify/polaris";
import withRouter from "helpers/withRouter";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { login } from '../../../../redux/features/auth/authSlice'
import AuthContainer from "../../AuthContainer";
import { createCustomDispatch } from "helpers/customDispatch";
import { getPostLoginRedirectUrl, isRedirectUrlSameProduct } from "utils/environment";
import eyeOnIMG from "img/icons/misc/eye-on.svg";
import eyeOffIMG from "img/icons/misc/eye-off.svg";

class LogInAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      errorEmail: false,
      password: "",
      errorPassword: false,
      showPassword: false,
    };
  }

  handleChangeCheckedRememberPassword = (value) => {
    this.setState({ passwordChecked: value });
  };

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  };

  validateLogin = (email) => {
    if (email.length === 0) {
      this.setState({
        errorEmail: `Enter your login`,
      });
    } else {
      this.setState({
        errorEmail: false,
      });
    }
  };

  doLogin = () => {
    const { email, password } = this.state;
    if (!password) {
      this.setState({ errorPassword: "Please enter your password and login" });
      return;
    }

    this.props
      .login(email, password)
      .then((res) => {
        		// Redirect after successful login
        const params = new URLSearchParams(window.location.search);
        const redirectUrl = params.get('redirectUrl');
        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1" ||
          window.location.hostname === "[::1]" ||
          /\.local$/.test(window.location.hostname);
        const getSubdomain = () => {
          switch (res.app_id) {
            case 1: return 'tax';
            case 2: return 'epr';
            case 3: return 'invoice';
            case 4: return 'tax-agent';
            case 5: return 'omp';
            default: return 'tax';
          }
        };
        if (redirectUrl && isRedirectUrlSameProduct(redirectUrl)) {
          window.location.href = redirectUrl;
        } else if (!isLocalhost) {
          const postLoginUrl = getPostLoginRedirectUrl(getSubdomain());
          window.location.href = postLoginUrl || `https://${getSubdomain()}${process.env.REACT_APP_COOKIES || ''}/`;
        } else {
          this.props.navigate("/home");
        }
        		// if isLocalhost, stay on localhost
      })
      .catch((err) => {
        this.setState({ errorPassword: "Email or password is incorrect" });
      });
  };

  render() {
    const { loggingIn } = this.props;
    const { email, errorEmail, password, errorPassword, showPassword } = this.state;

    return (
      <AuthContainer
        title={"Authorization"}
        description={"Please login to the system"}
        content={
          <FormLayout>
            <TextField
              name='email'
              type='text'
              placeholder='Login'
              value={email}
              error={errorEmail}
              onBlur={() => this.validateLogin(email)}
              onChange={(value) => {
                this.setState({ email: value });
              }}
            />
            <TextField
              name='password'
              type={showPassword ? 'text' : 'password'}
              placeholder='Password'
              value={password}
              error={errorPassword}
              suffix={
                <img
                  src={showPassword ? eyeOffIMG : eyeOnIMG}
                  alt={showPassword ? 'Hide password' : 'Show password'}
                  style={{
                    marginTop: 6,
                    cursor: 'pointer',
                    width: '20px',
                    height: '20px'
                  }}
                  onClick={this.togglePasswordVisibility}
                />
              }
              onChange={(value) => {
                this.setState({ password: value, errorPassword: false });
              }}
            />
            <Button
              disabled={loggingIn}
              loading={loggingIn}
              variant='primary'
              onClick={this.doLogin}
            >
              Sign In
            </Button>
          </FormLayout>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.auth.loggingInLoading,
  loginError: state.auth.loginError,
});

const mapDispatchToProps = (defaultDispatch) => {
  const dispatch = createCustomDispatch(defaultDispatch);

  return {
    login: (email, password) => dispatch(login({ email, password })),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(LogInAdmin))
);
